import { LinePath } from '@visx/shape';

import type { scaleLinear, scaleUtc } from '@visx/scale';
import { curveMonotoneX } from 'd3-shape';

interface Props {
  data: [Date, number][];
  strokeColor?:
    | 'var(--s-color-good)'
    | 'var(--s-color-bad)'
    | 'var(--s-color-p-white-100)';
  opacity?: number;
  xScale: ReturnType<typeof scaleUtc<number>>;
  yScale: ReturnType<typeof scaleLinear<number>>;
}

export const LinePlot = ({
  data,
  xScale,
  yScale,
  strokeColor = 'var(--s-color-p-white-100)',
  opacity = 1,
}: Props) => {
  return (
    <LinePath
      data={data}
      x={([date]) => xScale(date)}
      y={([_, value]) => yScale(value || 0)}
      stroke={strokeColor}
      strokeWidth={2}
      strokeLinecap="round"
      opacity={opacity}
      curve={curveMonotoneX}
    />
  );
};
